// extracted by mini-css-extract-plugin
export default {"content":"ZK6KUAff8t","message-icon":"kKyNl5PumO","messageIcon":"kKyNl5PumO","not-available":"xBLZMfUG8N","notAvailable":"xBLZMfUG8N","messages":"_0qH8b57nTO"};